/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */
/*
 * used to combine reducers to be used within the redux store.
 */
import { combineReducers } from '@ngt/reducer-registry';
/*
 * used to combine logics to be used within the redux store.
 */
import combineLogics from './combineLogics';
/*
 * ---------------------------------------------------------------------------------
 * Functions
 * ---------------------------------------------------------------------------------
 */
/**
 * This function subscribes the provided store to updates from the provided reducer registry.
 * @param store The store to subscribe.
 * @param reducerRegistry The reducer registry to subscribe too.
 * @param preloadState The preloaded state (if any).
 */
export var subscribeToReducerRegistry = function (store, reducerRegistry, logicMiddleWare, preloadState) {
    reducerRegistry.setOnRegister(function (reducers, logics) {
        store.replaceReducer(combineReducers(reducers, preloadState));
        logicMiddleWare.mergeNewLogic(combineLogics(logics));
    });
};
/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default subscribeToReducerRegistry;
//# sourceMappingURL=subscribeToReducerRegistry.js.map